export default "__VITE_ASSET__Cej_pNRi__"